module.exports = __webpack_public_path__ + "img/22.9da8fc95.svg";